import React from 'react';
import moment from 'moment';
import { Card } from 'react-bootstrap';

import GenericCardRenderItems from './GenericCardRenderItems';

const ComplementoCartaPorteUbicacionesResumen = ({ data = {}, onEdit, onDelete }) => {

  const render = (item) => (
    <GenericCardRenderItems
      key={ item.id }
      data={ item }
      labels={ labels }
    />
  )

  return (
    <>
      { !!data.Ubicaciones.Ubicacion &&  (
        <>
          <div className="d-block mt-3 mb-2">
            <strong>Ubicaciones</strong>
          </div>

          <Card className="mb-2">
            <Card.Body>
              { data.Ubicaciones.Ubicacion.map(render) }
            </Card.Body>
          </Card>
        </>
      ) }
    </>
  )
}

const labels = [
  {
    label: 'Tipo Ubicación',
    index: 'TipoUbicacion'
  },
  {
    label: 'ID Ubicación',
    index: 'IDUbicacion',
  },
  {
    label: 'RFC Remitente/Destinatario',
    index: 'RFCRemitenteDestinatario',
  },
  {
    label: 'Fecha Hora Salida/Llegada',
    index: 'FechaHoraSalidaLlegada',
    render: (value) => {
      return (
        <span>
          { moment(value).format('YYYY-MM-DDTHH:mm') + ':00' }
        </span>
      )
    }
  },
  {
    label: 'Distancia Recorrida',
    index: 'DistanciaRecorrida'
  }
];

export default ComplementoCartaPorteUbicacionesResumen;
